import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

import Document from "./Document";
import ResinSystem from "./ResinSystem";

import docIcon from "../images/icons/doc-big.png";
import pdfIcon from "../images/icons/pdf-big.png";
import provinceList from "../data/province-list";

import { siteInfoSheetManager } from "../_shark_jaws/managers/siteInfoSheetManager";

class SiteInfoSheet extends SmartModel {
	static STATUS_ARCHIVED_OLD_REVISION = 8;
	static STATUS_CONSTRUCTION_SITE_ENDED = 5;
	static STATUS_CONSTRUCTION_SITE_STARTED = 4;
	static STATUS_NEW = 0;
	static STATUS_QUOTATION_REFUSED = 3;
	static STATUS_READY = 1;
	static STATUS_STAND_BY = 2;

	__clientSolvencyMaxAmountEnsurableCSSClass = "danger";
	__showClientSolvencyMaxAmountEnsurable = false;

	constructor (data) {
		super();
		
		this.additionalNotes = {
			clientSolvencyAmountToEnsure: 0,
			clientSolvencyIPMNotes: "",
			clientSolvencyMaxAmountEnsurable: -1,
			clientSolvencyNotifications: [],
			clientSolvencyVATNumber: "",
			siteNeedsJoints: false,
			siteJointsCost: "",
			siteJointLength: "",
			siteNeedsSgusci: false,
			siteSgusciCost: "",
			siteSgusciLength: "",
			siteNeedsSlopeRecovery: false,
			siteSlopeRecoveryCost: "",
			siteSlopeRecoverySM: "",
			siteSmallSurfaceMarkup: false,
			siteClientSolvencyRequested: false,
			siteNeededVehicles: [],
			siteNeededVehicleSize: "",
			siteFurtherInfo: "",

			edging: false,
			edgingLength: 0,
			antiRoot: false,
			antiRootArea: 0,
			pipes: false,
			pipesLength: 0,
			drains: false,
			drainsQt: 0,
			drainsMeasures: 0,
			manholes: false,
			manholesQt: 0,
			manholesMeasures: 0,
			manholesFilling: false,
			sideDrainage: false,
			polyurethaneMembrane: false,
			slopeRecovery: "",
		};

		this.attachmentsGuids = [];
		
		this.clientGuid = "";
		this.clientName = "";

		this.chemicalAggressions = [];

		this.customer = null;
		this.customerGuid = "";
		this.designer = null;
		this.designerGuid = "";
		this.endUser = null;
		this.endUserGuid = "";

		this.extraData = {
			activityStatusId: 0, //1:...
			activityStatus: "",

			carriageables: {
				notes: "",
				requiredCarriageables: [],
			},
			disposal: false,
			disposalBy: "",
			logisticsNeeds: {
				electricCablePresent: false,
				electricGeneratorNeeded: false,
				existingsProtection: false,
				forkliftPresence: false,
				notes: "",
				pallets: false,
				palletsQt: 0,
				roadOrVehicleAccess: false,
				side: false,
				workOnAltitute: false,
			},

			presenceOf: {
				trees: false,
				treesQt: "",
				lights: false,
				lightsQt: "",
				joints: false,
				jointsQt: "",
				stairs: false,
				walls: false,
			},

			quotation: {
				cca: "",
				date: "0000-00-00 00:00:00",
				handDelivered: false,
				number: "",
				pdfURL: "",
				sendingDate: "0000-00-00 00:00:00",
				status: 0,//0: waiting, 1: pending, 2: accepted, 3: refused, 4: Uploaded
			},
			quotationRevisions: [],

			relatedGuids: {
				clientGuid: "",
				constructionSiteGuid: "",
				constructionSiteCardGuid: "",
				quotationGuid: "",
				visitGuid: "",
			},

			techSpecs: {
				aggregates01: false,
				aggregates01Type: "",
				aggregates01Area: 0,
				aggregates02: false,
				aggregates02Type: "",
				aggregates02Area: 0,
				aggregateChosenLater: false,
				aggregateChosenLaterArea: 0,

				aggregatesGreenPaving: false,
				aggregatesGreenPavingType: "",
				aggregatesGreenPavingArea: 0,

				aggregatePatterns: false,
				aggregatesMix: false,
				aggregateLuminescent: false,
				aggregateLuminescentArea: 0,

				cemColor: false,
				cemColorType: "",
				cemColorArea: 0,

				gummyFreetimRAL: false,
				gummyFreetimRALNotes: "",
				notes: "",
			},

			visitGuid: "",
		};

		this.floorType = [];
		this.floorSpecs = {
			specs: [],
			preciseSlope: false,
			preciseSlopePercent: 0,
			furtherNotes: ""
		};

		this.mechanicalStresses = {
			wheelPassages: [],
			passageWheelTypes: [],
			puncturings: [],
			puncturingType: "",
			thermicShockType: "",
			thermicShockTemp: "",
			furtherStresses: "",
		};

		this.notes = {
			genericNotes: "",
		};

		this.newFloorJob = {
			clsFinishes: {
				requiredFinishes: [],
				furtherInfo: "",
			},
			hasHydrostaticPressure: false,
			hydrostaticPressureInfo: "",
			sandAndCementScreedSupport: false,
			wallSupportNatures: [],
			wallSupportLimeInfo: "",
			wallSupportCementInfo: "",
			wallSupportDrywallInfo: "",
		};
			
		this.remakeJob = {
			actualWallFinishes: [],
			actualWallFinisheClsNote: "",
			alredyResinated: false,
			chemicalCorrosionPercent: "",
			hasChemicalCorrosion: "",
			humidityPercent: 0,
			notes: "",
			resinatedProcessing: "",
			sandAndCementScreedSupport: false,
		};
			
		this.preparations = {
			requiredPreparations: [],
			furtherInfo: "",
		};
		
		this.registry = {
			clientAddress: "",
			clientAddressAndCity: "",
			clientCity: "",
			clientCommoditySector: "",
			clientEMail: "",
			clientName: "",
			clientNationalLocationsCount: "",
			clientPersonInCharge: "",
			clientPersonInChargeRole: "",
			clientPersonInChargeMobile: "",
			clientProvince: "",
			clientRegion: "",
			clientZip: "",

			contactSource: 0,

			clientSiteLocation: "",
			customerGuid: "",//Committente 
			customerName: "",//Committente 
			designerGuid: "",//Progettista
			designerName: "",//Progettista
			endUserGuid: "",//Utilizzatore
			endUserName: "",//Utilizzatore
			receiver: "customer",
			siteLocation: {
				address: "",
				buyers: "",
				city: "",
				constructionCompanies: "",
				designers: "",
				interventionAreas: "",
				logisticNotes: "",
				name: "",
				personInCharge: {
					name: "",
					eMail: "",
					phone: ""
				},
				possibleAggressionsAndInteractions: "",
				province: "",
				region: "",
				zip: "",
			},

			sitePremiseDestinations: [],
			sitePremiseScope: "",
			siteVisitDate: "0000-00-00 00:00:00",
			siteSubstrateType: "",
			siteIPMPersonInCharge: "",

			quotationReceiver: {
				name: "",
				eMail: "",
				phone: ""
			},
		};
		this.systems = [];
		
		this.timeSpanAndApplicatorTeam = {
			applicatorTeamId: "",
			timeSpanEnd: "0000-00-00 00:00:00",
			timeSpanStart: "0000-00-00 00:00:00",
		};

		this.type = "";

		this.referenceDate = "0000-00-00 00:00:00";
		this.renewalReason = "";

		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.guid = "";
		this.latestFollowUp = "";
		this.newFollowUpCount = 0;
		this.pictures = [];
		this.quotationStatus = 0;
		this.revision = 0;
		this.revisionReferenceGuid = "";
		this.status = 0; //[1: normale, 3: Concluso per preventivo rifiutato, 4: Cantiere avviato, 5: Cantiere concluso, 8: Archiviato per revisione]
		this.userGuid = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
		this.year = new Date().getFullYear();
		this.yearNumber = 0;
		
		this.__agentName = "";
		this.__attachments = [];
		this.__customerName = "";
		this.__designerName = "";
		this.__endUserName = "";
		this.__errors = {};
		this.__errorsCount = 0;
		this.__firstPictureUrl = "";
		this.__followUpList = [];
		this.__hasFollowUp = false;
		this.__hasNewFollowUp = false;
		this.__isLastRevision = false;
		this.__quotationDate = "";
		this.__quotationPendingDays = -1;
		this.__quotationUploadedDays = -1;
		this.__quotationWaitingDays = -1;
		this.__referenceDate = "0000-00-00 00:00:00";
		this.__reportData = {
			province: "",
			sector: "",
		};
		this.__receiverIsCustomer = false;
		this.__receiverIsDesigner = false;
		this.__receiverIsEndUser = false;
		this.__revisionLabel = "";
		this.__showActualWallFinishHumidityPercent = false;
		this.__showNewJob = false;
		this.__showPreparationsFurtherInfo = false;
		this.__showRemakeJob = false;
		this.__sourceAppointmentGuid = "";
		this.__statusCSSClass = "";
		this.__timeSpanEnd = "0000-00-00 00:00:00";
		this.__timeSpanStart = "0000-00-00 00:00:00";
		this.__typeLabel = "";
		
		
		if (data) {
			//Dave.Warn: Questo import non mantiene i valori di default espressi sopra, verifica perché e risolvi.
			this.import(data);
		}
	}

	export () {
		var exportData = super.export();

		// if (exportData.customer) {
		// 	exportData.customer = this.exportData.customer.export();
		// }

		delete exportData.customer;
		delete exportData.designer;
		delete exportData.endUser;

		const localRegistry = Object.assign({}, this.registry);
		localRegistry.siteVisitDate = moment.utc(localRegistry.siteVisitDate).format(Shark.get("dateISODateTimeFormat"));
		
		const localTimeSpanAndApplicatorTeam = Object.assign({}, this.timeSpanAndApplicatorTeam);
		localTimeSpanAndApplicatorTeam.timeSpanEnd = moment.utc(localTimeSpanAndApplicatorTeam.timeSpanEnd).format(Shark.get("dateISODateTimeFormat"));
		localTimeSpanAndApplicatorTeam.timeSpanStart = moment.utc(localTimeSpanAndApplicatorTeam.timeSpanStart).format(Shark.get("dateISODateTimeFormat"));

		exportData.additionalNotes = JSON.stringify(this.additionalNotes);
		exportData.chemicalAggressions = JSON.stringify(this.chemicalAggressions);
		exportData.extraData = JSON.stringify(this.extraData);
		exportData.floorSpecs = JSON.stringify(this.floorSpecs);
		exportData.floorType = JSON.stringify(this.floorType);
		exportData.mechanicalStresses = JSON.stringify(this.mechanicalStresses);
		exportData.notes = JSON.stringify(this.notes);
		exportData.newFloorJob = JSON.stringify(this.newFloorJob);
		exportData.preparations = JSON.stringify(this.preparations);
		exportData.referenceDate = moment.utc(this.referenceDate).format(Shark.get("dateISODateTimeFormat"));
		exportData.registry = JSON.stringify(localRegistry);
		exportData.remakeJob = JSON.stringify(this.remakeJob);
		exportData.systems = JSON.stringify(this.systems.map(item => {
			const data = item.export();
			data.systems = data.systems.map(system => system.export());

			delete data.area;
			delete data.jobType;
			delete data.jobTypeSpec;
			delete data.scope;
			delete data.delete;
			delete data.thickness;
			delete data.systemNote;
			delete data.preparation;
			delete data.proposalGroup;
	
			return data;
		}));
		exportData.timeSpanAndApplicatorTeam = JSON.stringify(localTimeSpanAndApplicatorTeam);
		
		//Dave.ToDo: Questa pulizia la deve fare la libreria. Ma se le tolgo me li da come obbligatori... da risolvere
		// delete exportData.createdAt;
		// delete exportData.createdByGuid;
		// delete exportData.updatedAt;
		// delete exportData.updatedByGuid;

		// let exportPictures = [];

		// if (this.pictures.length > 0) {
		// 	exportPictures = this.pictures.map(item => item.url.substr((Shark.get("__cdnURL")).length + 1));
		// }
		exportData.attachmentsGuids = this.exportArrayField("attachmentsGuids");
		exportData.pictures = JSON.stringify(this.pictures);

		return exportData;
	}

	copyDataFromContact (contact) {
		if (contact) {
			const siteLocation = {
				address: contact.address,
				city: contact.city,
				province: contact.province,
				region: contact.region,
				zip: contact.zip,
				personInCharge: {
					eMail: contact.email,
					name: contact.contactPerson,
					phone: contact.phone,
				},
			};
	
			this.import({
				// clientGuid: contact.guid,
				// clientName: contact.name,
				registry: {
					// clientCommoditySector: contact.sector,
					// clientName: contact.name,
					// [`${receiverRole}Guid`]: contact.guid,
					// [`${receiverRole}Name`]: contact.name,
					siteLocation,
				}
			});
	
			return true;
		}
	
		return false;
	}

	getAutoFolderName() {
		let autoFolderName = (this.registry.siteLocation.name && this.registry.siteLocation.name.trim() !== "") ? this.registry.siteLocation.name : "Sede Legale";

		if (this.registry.siteLocation.interventionAreas && this.registry.siteLocation.interventionAreas.trim() !== "") {
			autoFolderName += " - " + this.registry.siteLocation.interventionAreas.trim();
		}

		return autoFolderName;
	}

	import (data, options) {
		this.__import(data, options);

		if (data.extraData && data.extraData !== "") {
			// this.extraData = Utils.parseJSON(data.extraData, "object");

			if (this.extraData.quotation) {
				if (this.extraData.quotation.sendingDate && this.extraData.quotation.sendingDate !== "" && this.extraData.quotation.sendingDate !== "0000-00-00 00:00:00") {
					const sendingDate = this.extraData.quotation.sendingDate;
					this.extraData.quotation.sendingDate = moment.utc(typeof sendingDate === "string" ? sendingDate : sendingDate.format("YYYY-MM-DD HH:mm:ss")).local();
				}
				if (this.extraData.quotation.date && this.extraData.quotation.date !== "" && this.extraData.quotation.date !== "0000-00-00 00:00:00") {
					this.__quotationDate = moment(this.extraData.quotation.date).format(Shark.get("dateHumanFormat"));
				}
			}
			else {
				this.extraData.quotation = {
					cca: "",
					date: "0000-00-00 00:00:00",
					handDelivered: false,
					number: "",
					pdfURL: "",
					sendingDate: "0000-00-00 00:00:00",
					status: 0,
				};
			}

			switch(this.extraData.quotation.status) {
				case 1:
					if (this.extraData.quotationRevisions && this.extraData.quotationRevisions.length > 0) {
						this.__quotationStatusLabel = `${this.extraData.quotationRevisions.length + 1} revisioni di Preventivi inviati`;
					}
					else {
						this.__quotationStatusLabel = "Preventivo inviato";
					}
					break;
				case 4:
					if (this.extraData.quotationRevisions && this.extraData.quotationRevisions.length > 0) {
						this.__quotationStatusLabel = `${this.extraData.quotationRevisions.length + 1} revisioni di Preventivi caricati`;
					}
					else {
						this.__quotationStatusLabel = "Preventivo caricato";
					}
					break;
			}
		}

		if (data.customer) {
			this.customer = Shark.getInstance("Client", data.customer);
		}
		if (data.designer) {
			this.designer = Shark.getInstance("Client", data.designer);
		}
		if (data.endUser) {
			this.endUser = Shark.getInstance("Client", data.endUser);
		}
		this.__showPreparationsFurtherInfo = this.preparations.requiredPreparations.indexOf("Altro") > -1;

		this.importNumberField("revision", data.revision);
		//this.revision = isNaN(parseInt(data.revision)) ? 0 : parseInt(data.revision);
		if (this.revision > 0) {
			this.__revisionLabel = ` <small>[rev. ${this.revision}]</small>`;
		}

		if (this.importDateField("registry.siteVisitDate", this.registry.siteVisitDate)) {
			this.__siteVisitDate = this.registry.siteVisitDate.format(Shark.get("dtIsoDate"));
			this.__siteVisitDateLabel = this.registry.siteVisitDate.format(Shark.get("dateHumanFormat"));
		}

		this.__reportData.province = this.registry.clientProvince;
		this.__reportData.sector = this.registry.clientCommoditySector;
		this.__sitePremiseScopePrivate = this.registry.sitePremiseScope === "private";
		this.__sitePremiseScopePublic = this.registry.sitePremiseScope === "public";

		if (data.systems && data.systems !== "") {
			const systems = Utils.parseJSON(data.systems, "array");

			// if (systems.length > 0 && systems[0].hasOwnProperty("area")) {
			if (systems.length > 0 && Object.prototype.hasOwnProperty.call(systems[0], "area")) {
				this.systems = systems.map(item => {
					//Dave.Warn: Non solo questa roba è duplicata qui, ma è anche duplicata da siteInfoSheetManager.createSystem
					const newPremiseDestination = Shark.getInstance("__smart__", {
						premiseDestination: item.premiseDestination,
						premiseNote: item.premiseNote,
						substrateType: item.substrateType,
						systems: systems.map(system => {
							const newSystem = new ResinSystem(system);
							return newSystem;
						}),
					});
			
					return newPremiseDestination;
				});
			}
			else {
				this.systems = systems.map(item => {
					//Dave.Warn: Non solo questa roba è duplicata qui, ma è anche duplicata da siteInfoSheetManager.createSystem
					const newPremiseDestination = Shark.getInstance("__smart__", {
						premiseDestination: item.premiseDestination,
						premiseNote: item.premiseNote,
						substrateType: item.substrateType,
						systems: item.systems.map(system => {
							const newSystem = new ResinSystem(system);
							return newSystem;
						}),
					});
			
					return newPremiseDestination;
				});
			}
			
			siteInfoSheetManager.reindexSystem(this);

			this.__showNewJob = false;
			this.__showRemakeJob = false;

			this.__areasLabel = "";
			this.__systemsLabel = "";
			this.systems.forEach(item => {
				if (item.systems) {
					item.systems.forEach(system => {
						let proposalGroupLabel = "";
						
						if (system.proposalGroup > -1) {
							proposalGroupLabel = system.proposalGroup === 0 ? ` <span class="text-primary icon-thumbs-up"></span>` : ` <span class="text-info">A${system.proposalGroup}</span>`;
							// proposalGroupLabel = system.proposalGroup === 0 ? "Proposta consigliata" : "Proposta alternativa " + system.proposalGroup;
							// proposalGroupLabel = " <small>(" + proposalGroupLabel + ")</small>";
						}

						let otherSystemNote = "";
						
						if (system.otherSystemNote !== "") {
							if (system.otherSystemNote.length <= 10) {
								otherSystemNote = " (" + system.otherSystemNote + ")";
							}
							else {
								otherSystemNote = `<span class="badge badge-info cursor-pointer ml-2 preventRowClick notClickable" style="font-size: 0.8em;" title="${system.otherSystemNote}" onclick="alert('${system.otherSystemNote}');"><span class="icon-info-circle notClickable"></span></span>`;
							}
						}
						
						this.__areasLabel += `<strong>${system.area}</strong> m<sup>2</sup> (<strong>${system.thickness}</strong> mm)<br>` ;
						this.__systemsLabel += `${system.system}${proposalGroupLabel}${otherSystemNote}<br>`;
						system.__printLabel = `${system.system}${proposalGroupLabel}`;
					}, this);
				}
				else {
					this.__areasLabel += `<strong>${item.area}</strong> m<sup>2</sup> (<strong>${item.thickness}</strong> mm)<br>` ;
					this.__systemsLabel += `${item.system}<br>` ;
				}
			}, this);
		}

		if (data.timeSpanAndApplicatorTeam && data.timeSpanAndApplicatorTeam !== "") {
			//this.timeSpanAndApplicatorTeam = Utils.parseJSON(data.timeSpanAndApplicatorTeam, "object");

			this.timeSpanAndApplicatorTeam.timeSpanEnd = moment.utc(this.timeSpanAndApplicatorTeam.timeSpanEnd).local();
			// this.importField("timeSpanAndApplicatorTeam.timeSpanEnd", data.timeSpanAndApplicatorTeam.timeSpanEnd, {dataType: "date"});
			this.__timeSpanEnd = this.timeSpanAndApplicatorTeam.timeSpanEnd.format(Shark.get("dtIsoDate"));
			this.__timeSpanEndLabel = this.timeSpanAndApplicatorTeam.timeSpanEnd.format(Shark.get("dateHumanFormat"));
			this.timeSpanAndApplicatorTeam.timeSpanStart = moment.utc(this.timeSpanAndApplicatorTeam.timeSpanStart).local();
			//this.importField("timeSpanAndApplicatorTeam.timeSpanStart", data.timeSpanAndApplicatorTeam.timeSpanStart, {dataType: "date"});
			this.__timeSpanStart = this.timeSpanAndApplicatorTeam.timeSpanStart.format(Shark.get("dtIsoDate"));
			this.__timeSpanStartLabel = this.timeSpanAndApplicatorTeam.timeSpanStart.format(Shark.get("dateHumanFormat"));

			const applicatorTeamList = Shark.get("applicatorTeamList");
			if (applicatorTeamList && this.timeSpanAndApplicatorTeam.applicatorTeamId !== "") {
				const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.timeSpanAndApplicatorTeam.applicatorTeamId);

				if (currApplicatorTeam) {
					this.__applicatorTeamName = currApplicatorTeam.name;
				}
			}
		}

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAt = this.createdAt.format(Shark.get("dtIsoDate"));
			this.__createdAtLabel = this.createdAt.format(Shark.get("dateHumanFormat"));
			this.__createdAtDateLabel = this.createdAt.format(Shark.get("dateTimeHumanFormat"));
		}

		this.importNumberField("newFollowUpCount", data.newFollowUpCount);

		if (this.importField("referenceDate", data.referenceDate, {dataType: "date", useUTC: true})) {
			this.__referenceDate = this.referenceDate.format(Shark.get("dtIsoDate"));
			this.__referenceDateLabel = this.referenceDate.format(Shark.get("dateHumanFormat"));
		}

		this.importNumberField("status", data.status);

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
		}
		this.importNumberField("year", data.year);
		this.importNumberField("yearNumber", data.yearNumber);

		if (isNaN(this.year) || this.year === 0) {
			this.year = this.createdAt.year();
		}

		if (this.pictures.length > 0) {
			this.__firstPictureUrl = this.pictures[0];
		}

		if (typeof data.latestFollowUp === "string") {
			this.latestFollowUp = data.latestFollowUp;
			this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		}
		// this.newFollowUpCount = parseInt(data.newFollowUpCount);
		this.__hasNewFollowUp = this.newFollowUpCount > 0;

		const agentList = Shark.get("agentList");
		if (agentList) {
			const currAgent = Utils.safp(agentList, "guid", this.userGuid);
			if (currAgent) {
				this.__agentName = currAgent.__fullName;
				this.__reportData.agentGuid = currAgent.guid;
				this.__reportData.agentName = currAgent.__fullName;
			}
		}

		this.__showActualWallFinishHumidityPercent = this.remakeJob.actualWallFinishes.indexOf("Umido") > -1;

		this.__receiverIsCustomer = this.registry.receiver === "customer";
		this.__receiverIsDesigner = this.registry.receiver === "designer";
		this.__receiverIsEndUser = this.registry.receiver === "endUser";

		this.__reportData.quotationStatus = this.extraData.quotation.status;

		//status: 0,//0: waiting, 1: pending, 2: accepted, 3: refused, 4: Uploaded
		if (typeof this.referenceDate.isValid === "function" && this.referenceDate.isValid()) {
			if (this.extraData.quotation.status === 0) {
				this.__quotationWaitingDays = moment().set({hour: 0, minute: 0, seconds: 0}).diff(this.createdAt.clone().set({hour: 0, minute: 0, seconds: 0}), "d");
				if (this.__quotationWaitingDays < 7) {
					this.__statusCSSClass = "site-info-sheet-status-waiting";
				}
				else {
					this.__statusCSSClass = "site-info-sheet-status-danger";//DAVE: NON ESISTE
				}

				if (this.__quotationWaitingDays === 1) {
					this.__waitingDaysLabel = " da un giorno";
				}
				else {
					this.__waitingDaysLabel = ` da ${this.__quotationWaitingDays} giorni`;
				}
			}
			else if (this.extraData.quotation.status === 1) {
				this.__quotationPendingDays = moment().set({hour: 0, minute: 0, seconds: 0}).diff((this.extraData.quotation.sendingDate ? this.extraData.quotation.sendingDate : this.referenceDate).clone().set({hour: 0, minute: 0, seconds: 0}), "d");
				this.__statusCSSClass = "site-info-sheet-status-quotation-sent";
			}
			else if (this.extraData.quotation.status === 4) {
				this.__quotationUploadedDays = moment().set({hour: 0, minute: 0, seconds: 0}).diff((this.extraData.quotation.sendingDate ? this.extraData.quotation.sendingDate : this.referenceDate).clone().set({hour: 0, minute: 0, seconds: 0}), "d");
				this.__statusCSSClass = "site-info-sheet-status-quotation-uploaded";
			}
		}

		this.importNumberField("quotationStatus", data.quotationStatus);
		//Dave: Questa roba non dovrei più basarlo sullo status ma su quotationStatus
		if (this.status === 3) {
			this.__statusLabel = "<span style=\"color: #FF0000;\">(Preventivo rifiutato)</span>";
		}
		else {
			if (this.quotationStatus && this.quotationStatus !== 0) {
				if ([2, 5, 7].indexOf(this.quotationStatus) > -1){
					this.__statusLabel = "<span style=\"color: #28A745;\">(Preventivo accettato)</span>";
				}
				else if ([1].indexOf(this.quotationStatus) > -1){
					this.__statusLabel = "<span style=\"color: #FFA500;\">(Preventivo in attesa)</span>";
				}
			}
		}

		this.__typeLabel = this.type === "industrial" ? "Industriale" : "Outdoor";

		this.__receiverIsCustomer = this.registry.receiver === "customer";
		this.__receiverIsDesigner = this.registry.receiver === "designer";
		this.__receiverIsEndUser = this.registry.receiver === "endUser";

		// Dave: Questa roba del "_[role]Name" è tutta da uniformare e gestire.
		this.__customerName = this.customerName || this.registry.customerName;
		this.__designerName = this.designerName || this.registry.designerName;
		this.__endUserName = this.endUserName || this.registry.endUserName;

		if (this.__customerName === "" && this.customer) {
			this.__customerName = this.customer.name;
		}

		if (this.__designerName === "" && this.designer) {
			this.__designerName = this.designer.name;
		}

		if (this.__endUserName === "" && this.endUser) {
			this.__endUserName = this.endUser.name;
		}

		switch (this.registry.receiver) {
			case "customer":
				this.__receiverNameLabel = this.registry.customerName || this.__customerName || this.registry.clientName;
				this.__receiverTypeLabel = "Committente";
				break;
			case "designer":
				this.__receiverNameLabel = this.registry.designerName || this.__designerName || this.registry.clientName;
				this.__receiverTypeLabel = "Progettista";
				break;
			case "endUser":
				this.__receiverNameLabel = this.registry.endUserName || this.__endUserName || this.registry.clientName;
				this.__receiverTypeLabel = "Utilizzatore Finale";
				break;
		}

		//Se c'è un committente è lui che va mostrato, se no si passa al progettista, se no all'utente finale (in teoria impossibile)
		if (this.__customerName.trim() !== "") {
			this.__receiverNameLabel = this.__customerName;
			this.__receiverCSSClass = "customer";
			this.__receiverTypeLabel = "Committente";
		}
		else if (this.__designerName.trim() !== "") {
			this.__receiverNameLabel = this.__designerName;
			this.__receiverCSSClass = "designer";
			this.__receiverTypeLabel = "Progettista";
		}
		else if (this.__endUserName.trim() !== "") {
			this.__receiverNameLabel = this.__endUserName;
			this.__receiverCSSClass = "endUser";
			this.__receiverTypeLabel = "Utilizzatore finale";
		}

		this.parseAttachment();
		this.parseSolvency();
		this.parseStatus();
		this.parseWallSupportNatures();
		this.evaluateSiteLocationLabel();
	}

	evaluateSiteLocationLabel () {
		if (this.registry.siteLocation.name !== "") {
			this.__siteLocationLabel = this.registry.siteLocation.name;
		}
		else {
			this.__siteLocationLabel = "Sede Legale";
		}

		if (this.registry.siteLocation.interventionAreas !== "") {
			this.__siteLocationLabel += " - " + this.registry.siteLocation.interventionAreas;
		}
	}

	isDirty () {
		if (this.__dirtyProperties.length > 0) {
			return true;
		}
		else {
			let isSistemDirty = false;
			
			for (let currArea of this.systems) {
				if (currArea.isDirty()) {
					isSistemDirty = true;
					break;
				}
				else {
					for (let currSystem of currArea.systems) {
						if (currSystem.isDirty()) {
							isSistemDirty = true;
							break;
						}
					}
				}
			}

			return isSistemDirty;
		}
	}

	isValid () {
		this.validate();

		return this.__isValid;
	}

	onDataChanged(data) {
		switch (data.property) {
			case "registry.customerGuid": {
				const customerContact = Utils.safp(Shark.get("clientList"), "guid", data.newValue);

				if (customerContact) {
					this.registry.customerName = customerContact.name;

					if (this.registry.receiver === "customer") {
						this.setContactAsReceiver(customerContact, "customer");
					}
				}
				break;
			}
			case "registry.designerGuid": {
				const designerContact = Utils.safp(Shark.get("clientList"), "guid", data.newValue);

				if (designerContact) {
					this.registry.designerName = designerContact.name;
					if (this.registry.receiver === "designer") {
						this.setContactAsReceiver(designerContact, "designer");
					}
				}
				break;
			}
			case "registry.endUserGuid":{
				const endUserContact = Utils.safp(Shark.get("clientList"), "guid", data.newValue);

				if (endUserContact) {
					this.registry.endUserName = endUserContact.name;
					if (this.registry.receiver === "endUser") {
						this.setContactAsReceiver(endUserContact, "endUser");
					}
				}
				break;
			}
			case "registry.clientProvince":
			case "registry.siteLocation.province": {
				this[data.property] = data.newValue.toUpperCase();
				const regionProperty = data.property.replace("province", "region").replace("Province", "Region");
				const regionField = document.querySelector(`input[data-sh-prop="${regionProperty}"]`);
				const region = provinceList.filter(item => item.plate === this[data.property]);

				if (region.length === 1) {
					this[regionProperty] = region[0].region;

					if (regionField) {
						regionField.value = this[regionProperty];
					}
				}
				break;
			}
			case "registry.receiver":
				this.__receiverIsCustomer = this.registry.receiver === "customer";
				this.__receiverIsDesigner = this.registry.receiver === "designer";
				this.__receiverIsEndUser = this.registry.receiver === "endUser";
				break;
			case "__followUpList":
				this.__hasFollowUp = this.__followUpList.length > 0;
				break;
			case "__referenceDate":
				this.referenceDate = moment(this.__referenceDate);
				break;
			case "__siteVisitDate":
				this.registry.siteVisitDate = moment(this.__siteVisitDate);
				break;
			case "__timeSpanEnd":
			case "__timeSpanStart":
				this.timeSpanAndApplicatorTeam[data.property.substr(2)] = moment(data.newValue);
				break;
		}
	}

	onAdditionalNotes_siteClientSolvencyRequestedChanged (data) {
		console.log(data);

		// this.__showClientSolvencyRequestedFields = this.additionalNotes.siteClientSolvencyRequested;
		Shark.render();
	}

	onStatusChanged () {
		this.parseStatus();
	}

	onNewValue (referenceModelField, newValue, eventTargetNode) {
		
		// if ([].includes(referenceModelField)) {

		// }
		// console.log(eventTargetNode.autoNumeric);
		
		return eventTargetNode?.autoNumeric?.rawValue ? parseFloat(eventTargetNode.autoNumeric.rawValue) : newValue;
	}

	parseAttachment () {
		this.__attachments = [];

		if (this.__attachments.length === 0 && this.attachmentsGuids.length > 0) {
			this.__attachments.push(...this.attachmentsGuids.map(guid => {
				return new Document({
					guid,
				});
			}));
		}

		if (this.pictures.length > 0) {
			this.__attachments.push(...this.pictures.filter(item => !this.attachmentsGuids.includes(item.guid), this).map(item => {
				item.fileURL = item.url;
				item.name = item.label;
				item.thumbnailURL = item.thumbURL;

				switch (item.type.toLowerCase()) {
					case "doc":
					case "docx":
						item.thumbnailURL = "/" + docIcon;
						break;
					case "pdf":
						item.thumbnailURL = "/" + pdfIcon;
						break;
				}

				return item;
			}));
		}
	}

	parseSolvency () {
		this.__showClientSolvencyMaxAmountEnsurable = this.additionalNotes.clientSolvencyAmountToEnsure > 0 && this.additionalNotes.clientSolvencyMaxAmountEnsurable >= 0;

		if (this.additionalNotes.clientSolvencyAmountToEnsure > 0) {
			const ensurableRatio = this.additionalNotes.clientSolvencyMaxAmountEnsurable / this.additionalNotes.clientSolvencyAmountToEnsure;
			this.__clientSolvencyMaxAmountEnsurableCSSClass = ensurableRatio >= .9 ? "success" : (ensurableRatio > 0 ? "warning" : "danger");
		}
	}

	parseStatus () {
		this.__quotation_waiting = this.extraData.quotation.status === 0 && this.status === SiteInfoSheet.STATUS_READY;
		this.__quotation_pending = this.extraData.quotation.status === 1;
		this.__quotation_uploaded = this.extraData.quotation.status === 4;

		this.__canBeDeleted = [SiteInfoSheet.STATUS_NEW, SiteInfoSheet.STATUS_READY, SiteInfoSheet.STATUS_STAND_BY].includes(this.status);
		this.__canBeInStandBy = [SiteInfoSheet.STATUS_NEW, SiteInfoSheet.STATUS_STAND_BY].includes(this.status);
	}

	parseWallSupportNatures () {
		this.__wallSupportNature_Lime = this.newFloorJob.wallSupportNatures.indexOf("Premiscelati con calce") > -1;
		this.__wallSupportNature_Cement = this.newFloorJob.wallSupportNatures.indexOf("Premiscelati con cemento") > -1;
		this.__wallSupportNature_Drywall = this.newFloorJob.wallSupportNatures.indexOf("Cartongesso") > -1;
	}

	setContactAsReceiver (contact, receiverRole = null) {
		if (contact) {
			receiverRole = receiverRole || this.__roleForContact || this.registry.receiver;

			const siteLocation = {
				address: contact.address,
				city: contact.city,
				province: contact.province,
				region: contact.region,
				zip: contact.zip,
				personInCharge: {
					eMail: contact.email,
					name: contact.contactPerson,
					phone: contact.phone,
				},
			};
	
			this.import({
				clientGuid: contact.guid,
				clientName: contact.name,
				[`${receiverRole}Guid`]: contact.guid,
				registry: {
					clientCommoditySector: contact.sector,
					clientName: contact.name,
					[`${receiverRole}Name`]: contact.name,
					siteLocation,
				}
			});
	
			if (this.registry.receiver !== receiverRole) {
				this.set({
					["registry.receiver"]: receiverRole,
				});
			}
			else {
				Shark.render();
			}
			return true;
		}
	
		return false;
	}

	matchAttachmentsWithDocuments (documentList) {
		this.__attachments = this.__attachments.map(item => {
			const document = Utils.safp(documentList, "guid", item.guid);

			return document || item;
		});
	}

	validate() {
		const errors = [];
		this.__errors = {};
		this.__errorsCount = 0;

		//let missingAreas = 0;

		// this.systems.forEach(item => {
		// 	if (item.area === "" || item.area === 0) {
		// 		missingAreas++;
		// 	}
		// });
		// if (missingAreas > 0) {
		// 	errors.push("Non hai indicato la superficie da coprire in almeno uno dei sistemi scelti");
		// }
		if (this.registry.customerGuid === "" && this.registry.designerGuid === "") {
			errors.push("Devi indicare almeno un contatto di riferimento tra Committente e Progettista");
			this.__errors.contacts = true;
			this.__errorsCount++;
		}
		if (!this.referenceDate.isValid()) {
			errors.push("La data della scheda non è valida");
			this.__errors.referenceDate = true;
			this.__errorsCount++;
		}

		if (!this.registry.siteLocation.name || this.registry.siteLocation.name.trim() === "") {
			errors.push("Devi inserire un nome per la sede");
			this.__errors.registry_siteLocation_name = true;
			this.__errorsCount++;
		}

		if (!this.registry.siteLocation.interventionAreas || this.registry.siteLocation.interventionAreas.trim() === "") {
			errors.push("Devi inserire un valore per le zone di intervento");
			this.__errors.registry_siteLocation_interventionAreas = true;
			this.__errorsCount++;
		}

		if (this.systems.length === 0) {
			errors.push("Devi inserire almeno un'Area di Utilizzo");
			this.__errors.systems = true;
			this.__errorsCount++;
		}
		else {
			this.systems.forEach((interventionArea/*, interventionAreaIndex*/) => {
				const proposalGroupCounts = {
					0: 0,
					1: 0,
					2: 0,
					3: 0,
					4: 0,
					5: 0,
				};

				if (interventionArea.systems.length === 0) {
					errors.push("Devi inserire almeno un sistema in ogni Area di Utilizzo");
					this.__errorsCount++;
				}
				else {
					interventionArea.systems.forEach((system/*, index*/) => {
						if (system.proposalGroup === "" || system.proposalGroup === -1) {
							errors.push("Devi indicare la proposta per tutti i sitemi");
							this.__errors.proposalGroup = true;
							this.__errorsCount++;
						}
						else {
							proposalGroupCounts[system.proposalGroup]++;
						}
						if (system.system === "") {
							errors.push("Devi scegliere un sistema in ogni proposta inserita");
							this.__errors.systems = true;
							this.__errorsCount++;
						}
						if (system.system === "ALTRO" && system.otherSystemNote.trim() === "") {
							errors.push("Devi dare indicazioni dove hai scelto 'altro' come Sistema");
							this.__errors.systems = true;
							this.__errorsCount++;
						}
					});
				}

				// for (let prop in proposalGroupCounts) {
				// 	if (proposalGroupCounts[prop] > 1) {
				// 		errors.push("Nell'area di utilizzo '" + interventionArea.premiseDestination + "' (numero " + (interventionAreaIndex + 1) + ") ci sono proposte ripetute, devi indicare un valore diverso per ogni Sistema inserito");
				// 		this.__errors.proposalGroup = true;
				// 		this.__errorsCount++;
				// 	}
				// }
			});
		}

		if (this.additionalNotes.siteClientSolvencyRequested && (this.additionalNotes.clientSolvencyVATNumber.trim() === "" || this.additionalNotes.clientSolvencyAmountToEnsure === 0)) {
			errors.push("Hai richiesto di valutare la solvibilità del cliente: devi indicare sia la Partita IVA che l'importo da assicurare.");
			this.__errors.additionalNotes_siteClientSolvencyRequested = true;
			this.__errors.additionalNotes_clientSolvencyVATNumber = true;
			this.__errors.additionalNotes_clientSolvencyAmountToEnsure = true;
			this.__errorsCount++;
		}

		



		// if (this.siteJobTypeAndPremiseDestination.trim() === "") {
		// 	errors.push("Il campo 'Natura del lavoro e destinazione locale' deve essere compilato");
		// }
		// if (this.siteSubstrateType.trim() === "") {
		// 	errors.push("Il tipo di sottofondo deve essere compilato");
		// }
		// if (this.preparations.length === 0) {
		// 	errors.push("Non hai indicato nessun tipo di preparazione");
		// }
		// if (this.actualWallSupportNatures.indexOf("Umido") > -1 && (this.actualWallSupportNaturesHumidityPercent.trim() === "" || parseInt(this.actualWallSupportNaturesHumidityPercent.trim()) === 0)) {
		// 	errors.push("Devi indicare la percentuale di umidità");
		// }
		// if (this.siteNeedsJoints && (this.siteJointsCost.trim() === "" || this.siteJointLength.trim() === "")) {
		// 	errors.push("Hai impostato la necessità di giunti ma non hai indicato i dettagli");
		// }
		// if (this.siteNeedsSgusci && (this.siteSgusciCost.trim() === "" || this.siteSgusciLength.trim() === "")) {
		// 	errors.push("Hai impostato la necessità di sgusci ma non hai indicato i dettagli");
		// }
		// if (this.siteNeedsSlopeRecovery === true && (this.siteSlopeRecoveryCost.trim() === "" || this.siteSlopeRecoverySM.trim() === "")) {
		// 	errors.push("Hai impostato la necessità di recupero di pendenze ma non hai indicato i dettagli");
		// }
		if (this.pictures.length === 0) {
			// errors.push("Devi aggiungere almeno un allegato");
		}

		this.__isValid = this.__errorsCount === 0;

		return errors;
	}
}

Shark.registerModel("SiteInfoSheet", SiteInfoSheet);

export default SiteInfoSheet;